module.exports = __webpack_public_path__ + "img/stock3.6159d281.png";